export enum Unit {
  'kW' = 'kW',
  'MW' = 'MW',
  'kWh' = 'kWh',
  'MWh' = 'MWh',
  'K' = 'K',
  'kVAr' = 'kVAr',
  'Nm3' = 'Nm3',
  'm3' = 'm3',
  'kWh/m3' = 'kWh/m3',
  'cEUR/m3' = 'cEUR/m3',
  'EUR/MWh' = 'EUR/MWh',
  'ratio' = 'ratio',
  'a' = 'a',
  'percentage' = '%',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  '%' = '%',
  'One' = 'One',
  'W' = 'W',
  'Kg Co2eq' = 'Kg Co2eq',
}
